import type React from "react";
import { Tooltip, Stack } from "@mui/material";
import UserInfoPopup from "./UserInfoPopup/UserInfoPopup";
import CompanyInfoPopup from "./CompanyInfoPopup/CompanyInfoPopup";
import { RequireAuth } from "@/components/RequireAuth";
import { getToken } from "@/helpers/cookiesHelper";

interface ProfileHoverCardProps {
  children: React.ReactElement;
  type: "user" | "company";
  uid?: string;
  symbol?: string;
}

export default function Popup({ children, uid, type, symbol }: ProfileHoverCardProps) {
  const token = getToken();
  if (!token) {
    return (
      <Stack
        direction="row"
        alignItems="center"
        width="fit-content"
        component="span"
        sx={{
          cursor: "pointer",
          display: type === "user" ? "flex" : "inline",
        }}
      >
        {children}
      </Stack>
    );
  }
  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: "100%",
            padding: "0",
            margin: "0",
            borderRadius: "16px",
            boxShadow: "0 32px 48px -8px rgba(0, 0, 0, 0.1), 0 0 14px -4px rgba(0, 0, 0, 0.05)",
            backgroundColor: "transparent !important",
            backdropFilter: "none !important",
          },
        },
      }}
      title={
        type === "user" ? (
          <RequireAuth>
            <UserInfoPopup uid={uid!} />
          </RequireAuth>
        ) : (
          <RequireAuth>
            <CompanyInfoPopup symbol={symbol} />
          </RequireAuth>
        )
      }
      placement="bottom-start"
    >
      <Stack
        direction="row"
        alignItems="center"
        width="fit-content"
        component="span"
        sx={{
          cursor: "pointer",
          display: "inline",
        }}
      >
        {children}
      </Stack>
    </Tooltip>
  );
}
